import { render, staticRenderFns } from "./dialog-add-multiple-list-members-text.vue?vue&type=template&id=5205f994&scoped=true&"
import script from "./dialog-add-multiple-list-members-text.vue?vue&type=script&lang=js&"
export * from "./dialog-add-multiple-list-members-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5205f994",
  null
  
)

export default component.exports